<template>
  <div class="pictures-box">
    <div class="header u-flex u-col-center u-row-between">
      <div></div>
      <div class="title">{{ $t('详情图片') }}</div>
      <i class="el-icon-close" @click="leftback"></i>
    </div>
    <i class="el-icon-close close" style="display: none;" @click="leftback"></i>
    <div class="pics u-flex u-col-center u-flex-wrap">
      <div class="pic" v-for="(item,index) in pics" :key="index">
        <img :src="item" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
		data() {
			return {
        pics: []
      }
    },
    created() {
			this.pics = JSON.parse(this.$route.query.pic)
		},
    methods: {
      leftback() {
        this.$router.go(-1)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>